module.exports = __webpack_public_path__ + "static/media/questionImg.95573847.svg";